import React from 'react'
import GitHub from '../assets/svg/github.svg'
import LinkedIn from '../assets/svg/linkedin.svg'
export default function SocialNetworks() {
    return (
    <>
        <div className='social-netwoks-bar'>
                <ul style={{display:'flex',justifyContent:'center'}}>
                    <a href='https://github.com/leanTate?tab=repositories' target="_blank" rel="noreferrer">
                        <img id='icon' className='icon1' src={GitHub} alt='a'/>
                    </a>
                    <a href='https://www.linkedin.com/in/leandro-tateossian-2aaa17213/' target="_blank" rel="noreferrer">
                        <img id='icon' className='icon1' src={LinkedIn} alt='a'/>
                    </a>
                        
                </ul>
        </div>
    </>
    )
}
